import React from 'react';
import { Spin } from 'antd';

interface LoadingSpinnerProps {
  tip?: string;
  fullScreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  tip = 'Carregando...',
  fullScreen = false,
}) => {
  if (fullScreen) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spin size="large" tip={tip}>
          <div className="p-12" />
        </Spin>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-8">
      <Spin size="large" tip={tip}>
        <div className="p-12" />
      </Spin>
    </div>
  );
};

export default LoadingSpinner;
